import { Playground, Props } from 'docz';
import { Button } from "../../../../src/Button/Button.tsx";
import React from 'react';
export default {
  Playground,
  Props,
  Button,
  React
};